import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_DescribeStreamProcessorCommand, se_DescribeStreamProcessorCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class DescribeStreamProcessorCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("RekognitionService", "DescribeStreamProcessor", {})
    .n("RekognitionClient", "DescribeStreamProcessorCommand")
    .f(void 0, void 0)
    .ser(se_DescribeStreamProcessorCommand)
    .de(de_DescribeStreamProcessorCommand)
    .build() {
}
